import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";

import SystemsOfLinearEquations from "./SystemsOfLinearEquations";
import VectorSpaces from "./VectorSpaces";
import MatrixOperations from "./MatrixOperations";
import LinearTransformations from "./LinearTransformations";
import Eigenvalues from "./Eigenvalues";
import MatrixDecomposition from "./MatrixDecomposition";
import TensorMathematics from "./TensorMath";
import NumericalLinearAlgebra from "./NumericalLinearAlgebra";

const ChangeComponents = {

    systemsoflinearequations: SystemsOfLinearEquations,
    vectorspaces: VectorSpaces,
    matrixoperations: MatrixOperations,
    lineartransformations: LinearTransformations,
    eigenvalues: Eigenvalues,
    matrixdecomposition: MatrixDecomposition,
    tensormathematics: TensorMathematics,
    numericallinearalgebra: NumericalLinearAlgebra,

  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }